/* =========================================
   CONTACT DRAWER
========================================= */

document.addEventListener("DOMContentLoaded", function () {

  const drawer = document.getElementById("contact-drawer");

  if (!drawer) return;

  /* ----------------------------------
     Buttons
  ---------------------------------- */

  const openButtons = document.querySelectorAll("[data-open-contact]");
  const openMessageButtons = document.querySelectorAll("[data-open-contact-message]");

  const closeButton = drawer.querySelector("[data-contact-drawer-close]");
  const underlay = drawer.querySelector("[data-contact-underlay]");

  const infoPage = drawer.querySelector('[data-contact-page="info"]');
  const formPage = drawer.querySelector('[data-contact-page="form"]');

  const openForm = drawer.querySelector("[data-open-contact-form]");
  const backButton = drawer.querySelector("[data-contact-back]");

  /* ----------------------------------
     Drawer
  ---------------------------------- */

  function openDrawer() {

    drawer.classList.add("is-open");
    document.body.classList.add("drawer-open");

  }

  function closeDrawer() {

    drawer.classList.remove("is-open");
    document.body.classList.remove("drawer-open");

  }

  /* ----------------------------------
     Pages
  ---------------------------------- */

  function showInfoPage() {

    infoPage.classList.remove("hidden");
    infoPage.classList.add("is-active");

    formPage.classList.add("hidden");
    formPage.classList.remove("is-active");

  }

  function showFormPage() {

    infoPage.classList.add("hidden");
    infoPage.classList.remove("is-active");

    formPage.classList.remove("hidden");
    formPage.classList.add("is-active");

  }

  /* ----------------------------------
     Public API
  ---------------------------------- */

  window.ContactDrawer = {

    open: function () {
      openDrawer();
      showInfoPage();
    },

    openForm: function () {
      openDrawer();
      showFormPage();
    },

    close: function () {
      closeDrawer();
    }

  };

  /* ----------------------------------
     Inside drawer
  ---------------------------------- */

  if (openForm) {

    openForm.addEventListener("click", function () {

      showFormPage();

    });

  }

  if (backButton) {

    backButton.addEventListener("click", function () {

      showInfoPage();

    });

  }

  /* ----------------------------------
     Contact button
  ---------------------------------- */

  openButtons.forEach(function (button) {

    button.addEventListener("click", function (e) {

      e.preventDefault();

      window.ContactDrawer.open();

    });

  });

  /* ----------------------------------
     Message button
  ---------------------------------- */

  openMessageButtons.forEach(function (button) {

    button.addEventListener("click", function (e) {

      e.preventDefault();

      window.ContactDrawer.openForm();

    });

  });

  /* ----------------------------------
     Close
  ---------------------------------- */

  if (closeButton) {

    closeButton.addEventListener("click", closeDrawer);

  }

  if (underlay) {

    underlay.addEventListener("click", closeDrawer);

  }

  document.addEventListener("keydown", function (e) {

    if (e.key === "Escape") {

      closeDrawer();

    }

  });

  /* ----------------------------------
     After Shopify success
  ---------------------------------- */

  if (
    window.location.search.indexOf("contact_posted=true") > -1 ||
    window.location.hash === "#contact_form"
  ) {

    openDrawer();
    showFormPage();

    const success = drawer.querySelector(".note--success");

    if (success) {

      setTimeout(function () {

        success.scrollIntoView({

          behavior: "smooth",
          block: "center"

        });

      }, 300);

    }

  }

});